"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualHomePropertyUseSummaryWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var FalconAccordionPlugin_1 = require("../../../components/FalconAccordionPlugin");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var SectionPanelTags_1 = require("../../SectionPanelTags");
var commonFunctions_1 = require("../../../commonFunctions");
var journey_services_1 = require("@athena-portal/journey-services");
var Detail = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "detail ".concat(className !== null && className !== void 0 ? className : ""), children: children }));
};
var DetailKey = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "detail-key ".concat(className !== null && className !== void 0 ? className : ""), children: children }));
};
var DetailValue = function (_a) {
    var className = _a.className, children = _a.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "detail-value ".concat(className !== null && className !== void 0 ? className : ""), children: children }));
};
var AnnualHomePropertyUseSummaryWidget = /** @class */ (function (_super) {
    __extends(AnnualHomePropertyUseSummaryWidget, _super);
    function AnnualHomePropertyUseSummaryWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.navigateToEditPropertyUsePage = function () {
            _this.props.engine.setJourneyState({
                idToScrollTo: "propertyUseWidgetId"
            });
            _this.props.engine.navigate("yourDetails", false);
        };
        _this.navigateToEditPropertyUseJourney = function () {
            _this.props.engine.navigate("propertyUse", false);
            journey_services_1.ObjectManipulator.setField("uistate.subprocess", _this.props.interaction, "changePropertyUse");
        };
        _this.fetchLookupValues = function () {
            var languageCode = "en-UK";
            var valuesToPopulate = [
                {
                    classifier: "residencyUsage",
                    field: _this.realEstate.residentsType,
                    stateName: "residencyUsage"
                },
                {
                    classifier: "propertyOccupancyType",
                    field: _this.realEstate.occupancyType,
                    stateName: "propertyOccupancy"
                },
                {
                    classifier: "propertyOwnershipType",
                    field: _this.realEstate.ownershipType,
                    stateName: "propertyOwnership"
                },
                {
                    classifier: "yearsLivedAtProperty",
                    field: _this.policyHolder.yearsAtProperty,
                    stateName: "yearsLivedAtProperty"
                }
            ];
            valuesToPopulate.forEach(function (item) {
                var lookupFieldValue = item.field == null ? undefined : item.field;
                _this.lookupService.fetchLookupValues(item.classifier, languageCode, lookupFieldValue).subscribe(function (lookupValues) {
                    var _a;
                    var fetchedLookupItem = lookupValues.find(function (lookupValue) { return lookupValue.id === item.field; });
                    if (fetchedLookupItem) {
                        _this.setState((_a = {}, _a[item.stateName] = fetchedLookupItem.value, _a));
                    }
                });
            });
        };
        _this.realEstate = _this.props.interaction.realEstate[0];
        _this.policyHolder = _this.props.interaction.policyHolder;
        _this.state = {
            residencyUsage: "",
            propertyOccupancy: "",
            propertyOwnership: "",
            yearsLivedAtProperty: "",
        };
        return _this;
    }
    AnnualHomePropertyUseSummaryWidget.prototype.componentDidMount = function () {
        this.fetchLookupValues();
    };
    AnnualHomePropertyUseSummaryWidget.prototype.render = function () {
        var process = this.props.interaction.process;
        var isNB = process === services_1.INTERACTION_PROCESS_NB;
        var hasDebt = this.props.interaction.factors.debtAmount > 0;
        var image = ((0, jsx_runtime_1.jsx)("img", { className: "home-image grid-row-1-2", src: "/".concat(services_1.resourcesHelper.THEME, "/img/home-icon-tick.svg"), alt: "Home icon with the tick" }));
        var button = ((0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary btn-add btn-summary-chapter", onClick: process === services_1.INTERACTION_PROCESS_NB
                ? this.navigateToEditPropertyUsePage
                : this.navigateToEditPropertyUseJourney, disabled: hasDebt, children: "Edit property use" }));
        if (isNB) {
            return ((0, jsx_runtime_1.jsx)("div", { id: "propertyUseWidgetId", className: "collapsible-question-panel quote-details-widget", children: (0, jsx_runtime_1.jsx)(FalconAccordionPlugin_1.FalconAccordion, { togglePositionTop: true, isShownClassName: "shown", toggleShown: this.renderToggle("collapse-icon"), toggleHidden: this.renderToggle("expand-icon"), children: (0, jsx_runtime_1.jsxs)("div", { className: "accordion-content grid-make-2-col", children: [image, (0, jsx_runtime_1.jsx)("div", { className: "section border-0 p-0", children: (0, jsx_runtime_1.jsx)("div", { className: "section-contents mb-5", children: this.renderPropertyUseDetails() }) }), button] }) }) }));
        }
        return ((0, jsx_runtime_1.jsx)(SectionPanelTags_1.SectionPanel, { className: "annual-home-mta align-items-center page-contents-home-inner", children: (0, jsx_runtime_1.jsxs)(SectionPanelTags_1.Section, { className: "insured-address-section", children: [image, (0, jsx_runtime_1.jsx)(SectionPanelTags_1.SectionHeading, { children: "Property use" }), (0, jsx_runtime_1.jsxs)(SectionPanelTags_1.SectionContents, { children: [this.renderPropertyUseDetails(), button] })] }) }));
    };
    AnnualHomePropertyUseSummaryWidget.prototype.renderPropertyUseDetails = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Main home:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.realEstate.isMainHome ? "Yes" : "No" })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Business use:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.realEstate.businessUse !== "NOT_USED" ? "Yes" : "No" })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "People living at the property:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.state.residencyUsage })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Number of adults:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.realEstate.adultFamilyMemberCount })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Children under 18 years old:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.realEstate.numberOfChildren !== 0 ? "Yes" : "No" })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Occupied property:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.state.propertyOccupancy })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Rent or own:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.state.propertyOwnership })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Cover type:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: (0, commonFunctions_1.getCoverLevelWording)(this.props.interaction.coverLevel) })] }), (0, jsx_runtime_1.jsxs)(Detail, { children: [(0, jsx_runtime_1.jsx)(DetailKey, { children: "Years lived at the property:" }), (0, jsx_runtime_1.jsx)(DetailValue, { children: this.state.yearsLivedAtProperty })] })] }));
    };
    AnnualHomePropertyUseSummaryWidget.prototype.renderToggle = function (iconClass) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "toggle d-flex justify-content-between align-items-center", children: [(0, jsx_runtime_1.jsx)("span", {}), (0, jsx_runtime_1.jsx)("span", { className: "font-weight-bold text-center fs-24", children: "Property use" }), (0, jsx_runtime_1.jsx)("span", { className: "toggle-icon ".concat(iconClass) })] }));
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], AnnualHomePropertyUseSummaryWidget.prototype, "lookupService", void 0);
    return AnnualHomePropertyUseSummaryWidget;
}(plugin_journey_1.WidgetBase));
exports.AnnualHomePropertyUseSummaryWidget = AnnualHomePropertyUseSummaryWidget;
//# sourceMappingURL=AnnualHomePropertyUseSummaryWidget.js.map